import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const TermsAndConditions: React.FC = () => {
  return (
    <div>
      <section className="pt-32 pb-12 bg-gradient-to-br from-primary to-primary/80 text-white">
        <div className="container mx-auto">
          <motion.div
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Termini e Condizioni</h1>
            <p className="text-xl text-white/80">
              Condizioni generali di utilizzo del sito web e del servizio di consulenza Servizio Bolletta
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-lg shadow-sm border border-light-border/50"
          >
            <div className="prose prose-lg max-w-none">
              <p className="text-sm text-light-muted italic">Ultimo aggiornamento: Gennaio 2026</p>

              <h2>Condizioni Generali di Utilizzo</h2>
              <p>
                I presenti Termini e Condizioni regolano l'accesso e l'utilizzo del sito web serviziobolletta.it 
                e dei servizi offerti da GT Energie Srl.
              </p>

              <h3>1. Identificazione del Titolare</h3>
              <ul>
                <li><strong>Ragione sociale:</strong> GT Energie Srl</li>
                <li><strong>Sede legale:</strong> Via Filippo Argelati 10, 20143 Milano (MI), Italia</li>
                <li><strong>P.IVA:</strong> IT02812720809</li>
                <li><strong>Email:</strong> info@serviziobolletta.it</li>
              </ul>

              <h3>2. Natura del Servizio</h3>
              <p>
                <strong>GT Energie Srl offre, tramite il marchio "Servizio Bolletta", un servizio gratuito di consulenza 
                e comparazione delle offerte</strong> per energia elettrica, gas naturale e connettività internet.
              </p>
              <ul>
                <li>GT Energie Srl <strong>non è un fornitore diretto</strong> di energia, gas o servizi internet</li>
                <li>GT Energie Srl opera come <strong>intermediario indipendente</strong></li>
                <li>Il servizio è <strong>completamente gratuito</strong> per l'utente</li>
                <li>La consulenza <strong>non implica alcun obbligo di sottoscrizione</strong></li>
                <li>L'eventuale adesione a un'offerta è una <strong>scelta libera e autonoma del cliente</strong></li>
                <li>Le offerte presenti sul sito hanno <strong>carattere puramente informativo</strong></li>
              </ul>

              <h3>3. Utilizzo del Sito</h3>
              <p>
                L'utente si impegna a utilizzare il sito esclusivamente per scopi leciti e in conformità 
                con i presenti Termini e Condizioni.
              </p>

              <h3>4. Informazioni e Offerte</h3>
              <p>
                Le informazioni, i prezzi e le offerte presentati sul sito sono forniti a <strong>titolo puramente 
                indicativo</strong>. I prezzi e le condizioni possono variare in qualsiasi momento su decisione dei fornitori.
              </p>

              <h3>5. Modello di Business</h3>
              <p>
                Il servizio è gratuito per l'utente. In alcuni casi, GT Energie Srl potrebbe percepire una 
                commissione commerciale dai fornitori partner qualora il cliente decida autonomamente di attivare 
                un'offerta. Questo non comporta alcun costo aggiuntivo per il cliente.
              </p>

              <h3>6. Proprietà Intellettuale</h3>
              <p>
                Tutti i contenuti presenti sul sito sono di proprietà di GT Energie Srl o dei rispettivi licenzianti 
                e sono protetti dalle leggi sul diritto d'autore.
              </p>

              <h3>7. Limitazione di Responsabilità</h3>
              <p>
                GT Energie Srl non è responsabile per i servizi forniti da terze parti (fornitori) con cui 
                l'utente dovesse stipulare un contratto.
              </p>

              <h3>8. Privacy e Cookie</h3>
              <p>
                Il trattamento dei dati personali è regolato dalla nostra{' '}
                <Link to="/privacy-policy" className="text-primary hover:underline">Privacy Policy</Link>.
                L'utilizzo dei cookie è descritto nella nostra{' '}
                <Link to="/cookie-policy" className="text-primary hover:underline">Cookie Policy</Link>.
              </p>

              <h3>9. Legge Applicabile</h3>
              <p>
                I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia sarà competente 
                il Tribunale di Milano, fatte salve le norme inderogabili a tutela del consumatore.
              </p>

              <h3>10. Contatti</h3>
              <ul>
                <li><strong>Email:</strong> info@serviziobolletta.it</li>
                <li><strong>Indirizzo:</strong> GT Energie Srl, Via Filippo Argelati 10, 20143 Milano (MI), Italia</li>
                <li><strong>P.IVA:</strong> IT02812720809</li>
              </ul>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
